import { writable } from 'svelte/store'
import { storable } from 'kitto/svelte'

interface UI {
	main: HTMLElement | null
	search: boolean
	menu: boolean
	subscribe: boolean
	email: string
	shortcuts: boolean
	immersive: boolean
}

export const ui = writable<UI>({
	main: null,
	search: false,
	menu: false,
	subscribe: false,
	email: '',
	shortcuts: false,
	immersive: false
})

interface Storable {
	cookie?: boolean
}

export const prefs = storable<Storable>({ cookie: undefined }, 'prefs')
